var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBaloonSmall = function SvgBaloonSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 57,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M56.181 26.951a28.16 28.16 0 0 0-36.27-25.75 27.3 27.3 0 0 0-18.71 18.7 28.38 28.38 0 0 0 21.62 36c.21 0 .5.11.72.14.618.106 1.244.16 1.87.16h29.41a3 3 0 0 0 2.23-4.94l-1-1.08a6.11 6.11 0 0 1-1.44-3 8.2 8.2 0 0 1 0-3.16 71.233 71.233 0 0 0 1.55-17.13l.02.06Z",
    opacity: 0.8
  })));
};
export default SvgBaloonSmall;